import { get } from '../index';

export const getModelFileList = (companyId) => {
  return get(`/model-file/${companyId}`);
};
